<template>
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7119_61411)">
      <mask
        id="mask0_7119_61411"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="15"
        height="15"
      >
        <path d="M15 0H0V15H15V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_7119_61411)">
        <path
          d="M8.46519 6.53553C7.95325 6.0238 7.25903 5.73633 6.53519 5.73633C5.81134 5.73633 5.11713 6.0238 4.60519 6.53553L2.67456 8.46553C2.16261 8.97748 1.875 9.67183 1.875 10.3958C1.875 11.1198 2.16261 11.8142 2.67456 12.3262C3.18651 12.8381 3.88087 13.1257 4.60487 13.1257C5.32888 13.1257 6.02324 12.8381 6.53519 12.3262L7.50019 11.3612"
          stroke="#FF6347"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.53516 8.46519C7.0471 8.97691 7.74131 9.26438 8.46516 9.26438C9.189 9.26438 9.88321 8.97691 10.3952 8.46519L12.3258 6.53519C12.8377 6.02324 13.1253 5.32888 13.1253 4.60487C13.1253 3.88087 12.8377 3.18651 12.3258 2.67456C11.8138 2.16261 11.1195 1.875 10.3955 1.875C9.67146 1.875 8.97711 2.16261 8.46516 2.67456L7.50016 3.63956"
          stroke="#FF6347"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_7119_61411">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
